export { default } from './CookieWidget';
